import React, { useState } from 'react'
import { logEvent } from '../../utils/firebase'
import {
  BlogEmailInput,
  BlogEmailLabel,
  BlogEmailSubscribeButton,
  BlogEmailSubscriptionBlock,
  EmailSubscriptionForm
} from './BlogEmailSubscription.styles'

export const BlogEmailSubscription = ({ withBackground }) => {
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState(null)

  const handleSubmit = async e => {
    e.preventDefault()

    if (!email) return

    const request = await fetch(`/api/subscribe?email=${email}`)

    if (request.status === 200) {
      logEvent('blog_subscription_submission', {})
      setSuccess(true)
    } else {
      setSuccess(false)
    }
  }

  return (
    <BlogEmailSubscriptionBlock withBackground={withBackground}>
      <EmailSubscriptionForm method="post" onSubmit={handleSubmit}>
        <BlogEmailLabel>
          Subscribe to our blog for more interior design tips and trends!
        </BlogEmailLabel>
        <BlogEmailInput
          type="email"
          placeholder="Enter your email"
          name="EMAIL"
          id="mce-EMAIL"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <BlogEmailSubscribeButton
          type="submit"
          disabled={success !== null}
          value={success === null ? 'Subscribe' : 'Thank you!'}
          name="subscribe"
          id="mc-embedded-subscribe"
        />
      </EmailSubscriptionForm>
    </BlogEmailSubscriptionBlock>
  )
}
